module.exports = __webpack_public_path__ + "img/fore.7cfe5166.png";